import { ref, readonly } from 'vue';
import { NotificationOptions, Notification } from './types';

const notification = ref<Notification | null>(null);
let nextId = 0;
let timerId: NodeJS.Timeout | null = null;

export function useNotification() {
  const show = (options: NotificationOptions) => {
    clearTimeout(timerId);
    
    const notificationNew: Notification = {
      id: nextId++,
      ...options
    };
    
    notification.value = notificationNew;
    
    if (options.duration !== 0) {
      timerId = setTimeout(() => {
        clear();
      }, options.duration || 2000);
    }
    
    return notificationNew.id;
  };

  const clear = () => {
    notification.value = null;
    
    if (timerId) {
      clearTimeout(timerId);
    }
  };

  return {
    notification: readonly(notification),
    show,
    clear
  };
}